export default "__VITE_ASSET__E$_ixxzJ__"